import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
    //loadChildren: './modules/dashboard/dashboard.module#DashboardModule',
    canActivate: [AuthGuard],
  },
  {
    path: 'orders',
    loadChildren: () => import('./modules/order/order.module').then(m => m.OrderModule),
    //loadChildren: './modules/order/order.module#OrderModule',
    canActivate: [AuthGuard],
  },
  {
    path: 'admin',
    loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule),
    //loadChildren: './modules/admin/admin.module#AdminModule',
    canActivate: [AuthGuard],
  },
  {
    path: 'problem',
    loadChildren: () => import('./modules/problem/problem.module').then(m => m.ProblemModule),
    //loadChildren: './modules/problem/problem.module#ProblemModule',
    canActivate: [AuthGuard],
  },
  {
    path: 'self-diagnostic',
    loadChildren: () => import('./modules/self-diagnostic/self-diagnostic.module').then(m => m.SelfDiagnosticModule),
    //loadChildren: './modules/self-diagnostic/self-diagnostic.module#SelfDiagnosticModule',
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule),
    //loadChildren: './modules/login/login.module#LoginModule'
  },
  {
    path: 'profile',
    loadComponent: () => import('./modules/user-profile/user-profile.component').then(c => c.UserProfileComponent),
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
